import {
  Button,
  FormControlSizes,
  IconName,
  MixpanelEvent,
  MixpanelEventProperty,
  MixpanelEventSource,
  useMixpanel,
} from '@talos/kyoko';

const KB_URL = 'https://kb.talostrading.com/principal-trading/pre-trade-analytics';

interface PreTradeKBLinkButtonProps {
  label?: string;
  showStartIcon?: boolean;
}

export function PreTradeKBLinkButton({
  label = 'Knowledge Base',
  showStartIcon = true,
}: PreTradeKBLinkButtonProps = {}) {
  const mixpanel = useMixpanel();

  return (
    <Button
      size={FormControlSizes.Small}
      startIcon={showStartIcon ? IconName.BookOpen : undefined}
      endIcon={IconName.ExternalLink}
      onClick={() => {
        mixpanel.track(MixpanelEvent.OpenKnowledgeBase, {
          [MixpanelEventProperty.Source]: MixpanelEventSource.PreTrade,
        });
        window.open(KB_URL, '_blank', 'noopener,noreferrer');
      }}
    >
      {label}
    </Button>
  );
}
